/**
 * @file Generated by js-routes 2.3.5. Based on Rails 8.0.2.1 routes of LawFi::Application.
 * @version dbf4f7445ec4ebffa4054e1da8f3a01f0bb93672362ff8c5c6ec5477a442d629
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /invitations/:id/accept(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_invitation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_user_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/bank_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_bank_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bank_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bank_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_bank_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bank_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/fee_batches/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_fee_batch_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"fee_batches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/fee_batches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_fee_batches_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"fee_batches"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/firms/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_firm_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/firms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_firms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"firms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/fund_batches/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_fund_batch_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"fund_batches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/fund_batches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_fund_batches_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"fund_batches"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/loans/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_loan_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/loans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_loans_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loans"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/portfolios/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_portfolio_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"portfolios"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/portfolios(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_portfolios_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"portfolios"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/transfers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_transfer_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"transfers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/transfers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_transfers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"transfers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/loans/applications(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applications_firm_loans_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"loans"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/fee_batches/:id/approval(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approval_admin_fee_batch_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"fee_batches"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approval"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/fund_batches/:id/approval(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approval_admin_fund_batch_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"fund_batches"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approval"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/portfolios/:id/approval(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approval_admin_portfolio_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"portfolios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approval"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/firms/:slug/approve(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_admin_firm_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/loans/:id/assign(.:format)
 * @param {any} firm_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_firm_loan_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"loans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/loans/:id/cancel(.:format)
 * @param {any} firm_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_firm_loan_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"loans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sign-up/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign-up"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/stakeholders/:stakeholder_id/verification/complete(.:format)
 * @param {any} firm_slug
 * @param {any} stakeholder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_firm_stakeholder_verification_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"stakeholder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"stakeholders"],[2,[7,"/"],[2,[3,"stakeholder_id"],[2,[7,"/"],[2,[6,"verification"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /firms/:slug/edit(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_firm_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/offices/:slug/edit(.:format)
 * @param {any} firm_slug
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_firm_office_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"offices"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sign-up/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign-up"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /firms/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/bank_accounts/:id(.:format)
 * @param {any} firm_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_bank_account_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"bank_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/bank_accounts(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_bank_accounts_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"bank_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/configuration(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_configuration_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/debit_agreement(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_debit_agreement_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"debit_agreement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/documents(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_documents_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/employments/:id(.:format)
 * @param {any} firm_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_employment_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"employments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/employments(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_employments_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"employments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/financing_survey(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_financing_survey_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"financing_survey"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/loans(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_loans_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"loans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/logo(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_logo_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"logo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/merchant_agreement(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_merchant_agreement_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"merchant_agreement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/offices/:slug(.:format)
 * @param {any} firm_slug
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_office_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"offices"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/offices(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_offices_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"offices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/service_types(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_service_types_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"service_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/stakeholders/:id(.:format)
 * @param {any} firm_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_stakeholder_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"stakeholders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/stakeholders/:stakeholder_id/verification(.:format)
 * @param {any} firm_slug
 * @param {any} stakeholder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_stakeholder_verification_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"stakeholder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"stakeholders"],[2,[7,"/"],[2,[3,"stakeholder_id"],[2,[7,"/"],[2,[6,"verification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/stakeholders(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_stakeholders_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"stakeholders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/theme(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_theme_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"theme"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/tools(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_tools_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"tools"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/transactions(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_transactions_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/trust_plan(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firm_trust_plan_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"trust_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"firms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /invitations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/firms/:slug/live(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const live_admin_firm_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"live"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:firm_slug(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loan_applications_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"firm_slug"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /user/mfa(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mfa_user_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"mfa"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/fee_batches/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_fee_batch_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"fee_batches"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/fund_batches/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_fund_batch_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"fund_batches"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/portfolios/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_portfolio_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"portfolios"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_firm_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/bank_accounts/new(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_firm_bank_account_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"bank_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:firm_slug(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_loan_application_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"firm_slug"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sign-up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign-up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /login/otp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const otp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[2,[7,"/"],[2,[6,"otp"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/bank_accounts/plaid_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plaid_link_admin_bank_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bank_accounts"],[2,[7,"/"],[2,[6,"plaid_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/bank_accounts/plaid_link(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plaid_link_firm_bank_accounts_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"bank_accounts"],[2,[7,"/"],[2,[6,"plaid_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/bank_accounts/:id/plaid_relink(.:format)
 * @param {any} firm_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plaid_relink_firm_bank_account_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"bank_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"plaid_relink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/bank_accounts/:id/plaid_verify(.:format)
 * @param {any} firm_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plaid_verify_firm_bank_account_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"bank_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"plaid_verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user/profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_user_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /manifest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pwa_manifest_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manifest"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/bank_accounts/:id/relink(.:format)
 * @param {any} firm_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relink_firm_bank_account_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"bank_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/employments/:id/resend_invitation(.:format)
 * @param {any} firm_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_invitation_firm_employment_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"employments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_invitation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/stakeholders/:id/resend_invitation(.:format)
 * @param {any} firm_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_invitation_firm_stakeholder_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"stakeholders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_invitation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:firm_slug/:loan_id/resend(.:format)
 * @param {any} firm_slug
 * @param {any} loan_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_loan_application_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"loan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[3,"loan_id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:firm_slug/resume(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resume_loan_application_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/reports/revenue(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revenue_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"revenue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:slug/review(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const review_firm_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /user/security(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_user_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"security"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:firm_slug/s/:id(.:format)
 * @param {any} firm_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const short_stakeholder_invitation_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:firm_slug/s/:id/v(.:format)
 * @param {any} firm_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const short_stakeholder_verified_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"v"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/trust_plan/skip(.:format)
 * @param {any} firm_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skip_firm_trust_plan_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"trust_plan"],[2,[7,"/"],[2,[6,"skip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/stakeholders/:stakeholder_id/verification/start(.:format)
 * @param {any} firm_slug
 * @param {any} stakeholder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_firm_stakeholder_verification_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"stakeholder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"stakeholders"],[2,[7,"/"],[2,[3,"stakeholder_id"],[2,[7,"/"],[2,[6,"verification"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/loans/:id/unassign(.:format)
 * @param {any} firm_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unassign_firm_loan_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"loans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unassign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user/otp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_otp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"otp"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /user/phone(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_phone_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"phone"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sign-up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign-up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/stakeholders/:stakeholder_id/verification/validate(.:format)
 * @param {any} firm_slug
 * @param {any} stakeholder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_firm_stakeholder_verification_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"stakeholder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"stakeholders"],[2,[7,"/"],[2,[3,"stakeholder_id"],[2,[7,"/"],[2,[6,"verification"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/stakeholders/:stakeholder_id/verification/verified(.:format)
 * @param {any} firm_slug
 * @param {any} stakeholder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verified_firm_stakeholder_verification_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"stakeholder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"stakeholders"],[2,[7,"/"],[2,[3,"stakeholder_id"],[2,[7,"/"],[2,[6,"verification"],[2,[7,"/"],[2,[6,"verified"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /firms/:firm_slug/bank_accounts/:id/verify(.:format)
 * @param {any} firm_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_firm_bank_account_path = /*#__PURE__*/ __jsr.r({"firm_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"firms"],[2,[7,"/"],[2,[3,"firm_slug"],[2,[7,"/"],[2,[6,"bank_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user/phone/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_user_phone_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"phone"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

